// all the test and stage envs are built and run with NODE_ENV=production
export const isProduction = () => process.env.NODE_ENV === 'production'

export const isDev = () => process.env.NODE_ENV === 'development'

export const isEnv = (envName: string) => process.env.NODE_ENV === envName
